import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { IProcessStatus } from '@app/interfaces/process.interface';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IOrg, IPartner, IUsersItems } from '../../domain/models/admin';
import { IAdminModalComponent, IAdminModalData } from '../../domain/models/admin-modal';
import { AdminResourcesService } from '../../services/admin.service';

@Component({
	selector: 'app-admin-assign-modal',
	templateUrl: './admin-assign-modal.component.html',
	styleUrls: ['./admin-assign-modal.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class AdminAssignModalComponent implements IAdminModalComponent, OnInit, OnDestroy {
	unsubscribe$: Subject<boolean> = new Subject<boolean>();
	@Input() data: IAdminModalData<{}>;
	node: IUsersItems | IPartner;
	orgsList: IOrg[];
	showConfirm = false;
	initProcess = false;
	processStatus: BehaviorSubject<IProcessStatus> = new BehaviorSubject<IProcessStatus>(IProcessStatus.loading);
	selectedOrgs = [];
	usageMode: 'user' | 'partner';
	whitelabels: string[];
	selectedWl: string;

	get isApplyDisabled(): boolean {
		return this.usageMode === 'user' && !this.selectedWl;
	}

	constructor(private readonly adminResourcesService: AdminResourcesService) {}

	ngOnInit(): void {
		this.orgsList = this.data.options['orgs'];
		this.node = this.data.options['node'];
		this.usageMode = this.data.options['mode'];

		if (this.usageMode === 'user') {
			// prevent assign 'All' whitelabels
			this.whitelabels = this.data.options['whitelabels'];
			this.selectedWl = this.data.options['selectedWl'] !== 'All' ? this.data.options['selectedWl'] : null;
		}

		this.selectedOrgs = this.getSelectedOrgs(this.node);
	}

	getSelectedOrgs(node): number[] | string[] {
		return this.usageMode === 'user' ? node.organisations : node.organizations.map(Number);
	}

	getName(): string {
		return this.usageMode === 'user' ? (this.node as IUsersItems).nickname : (this.node as IPartner).reseller_name;
	}

	ngOnDestroy(): void {
		this.unsubscribe$.next(true);
		this.unsubscribe$.complete();
	}

	onConfirmed(isConfirmed: boolean): void {
		if (isConfirmed) {
			this.showConfirm = false;
			this.usageMode === 'user' ? this.onUserAssign() : this.onAssignOrgToPartner();
		} else {
			this.showConfirm = false;
		}
	}

	onAssignOrgToPartner(): void {
		this.initProcess = true;
		const id = (this.node as IPartner).reseller_id;
		const orgs = this.selectedOrgs.map(String);

		this.adminResourcesService
			.assignOrgToPartner(orgs, id)
			.pipe(takeUntil(this.unsubscribe$))
			.subscribe({
				next: (res) => {
					this.processStatus.next(IProcessStatus.done);
					setTimeout(() => {
						this.closeEvent({ message: status });
					}, 500);
				},
			});
	}

	onUserAssign(): void {
		this.initProcess = true;
		const uuid = (this.node as IUsersItems).uuid;
		const whitelabel = this.data.options['partners'].find((wl) => wl.reseller_name === this.selectedWl).whitelabel;

		this.adminResourcesService
			.assignToOrg(this.selectedOrgs, uuid, whitelabel)
			.pipe(takeUntil(this.unsubscribe$))
			.subscribe({
				next: (res) => {
					const status: IProcessStatus = res.success ? IProcessStatus.done : IProcessStatus.failed;
					this.processStatus.next(status);
					setTimeout(() => {
						this.closeEvent({ message: status });
					}, 1500);
				},
			});
	}

	customSearchFn(term: string, item: IOrg): boolean {
		term = term.toLocaleLowerCase();
		let result;
		try {
			result =
				(item.org_name && item.org_name.toLocaleLowerCase().indexOf(term) > -1) ||
				(item.org_id && item.org_id.toString().indexOf(term) > -1);
		} catch (e) {
			result = false;
		}

		return result;
	}

	confirm(): void {
		this.showConfirm = true;
	}

	closeEvent(e?: {}): void {}
}
